import { getGlobalThis } from '@cap/ssr-common-utils';
import { TerminalType, ACCOUNT_TYPE } from '../constants';

export interface BootstrapOptions {
  /**
   * app行时环境，支持 'local' | 'test' | 'staging' | 'production'
   */
  env: 'local' | 'test' | 'staging' | 'production';
  /**
   * 终端类型
   */
  terminalType: TerminalType;
  /**
   * 应用所需的账号类型，目前只支持 2: Passport（C端账号）； 3: EPassport(商家账号)
   */
  accountType: ACCOUNT_TYPE;
  /**
   * 本地开发或测试环境下的泳道标识。外部业务接入不需要配置
   */
  swimlane?: string;
  /**
   * 业务投放的渠道标识
   */
  source?: string;
}

export function bootstrap(options: BootstrapOptions) {
  const that = getGlobalThis();
  that.runtime_env = Object.seal({
    ...options,
  });
}
